import { HttpParams } from '@angular/common/http';
import { ExportBuildingsModel } from '../../models/export-buildings.model';
import { ImportBuildingModel } from '../../models/import-buildings.model';
import { BuildingFilterModel } from './../../models/building-filter.model';
import { BuildingModel } from './../../models/building.model';
import { SearchStreet } from './../../models/search-street.model';

export class GetAllBuildingMarkers {
  static readonly type = '[Building-State] Get All Building Markers';
  constructor() {}
}

export class FilterBuildings {
  static readonly type = '[Building-State] Filter Buildings';
  constructor(public params: HttpParams, public filter?: BuildingFilterModel) {}
}

export class GetBuilding {
  static readonly type = '[Building-State] GEt Building';
  constructor(public id: string) {}
}

export class AddBuilding {
  static readonly type = '[Building-State] Add Building';
  constructor(public model: BuildingModel) {}
}

export class EditBuilding {
  static readonly type = '[Building-State] Edit Building';
  constructor(public model: BuildingModel) {}
}

export class RemoveBuilding {
  static readonly type = '[Building-State] Remove Building';
  constructor(public modelId: string) {}
}

export class ImportBuildings {
  static readonly type = '[Building-State] Import Buildings';
  constructor(public model: ImportBuildingModel) {}
}

export class ExportBuildings {
  static readonly type = '[Building-State] Export Buildings';
  constructor(public model: ExportBuildingsModel) {}
}

export class SelectBuilding {
  static readonly type = '[Building-State] Select Building';
  constructor(public model: BuildingModel) {}
}

export class ClearSelectedBuilding {
  static readonly type = '[Building-State] Select Building';
  constructor() {}
}

export class ClearBuildings {
  static readonly type = '[Building-State] Clear Buildings';
  constructor() {}
}

export class SearchByStreet {
  static readonly type = '[Building-State] Search by street';
  constructor(public searchStreet: SearchStreet) {}
}

export class GetBuildingCategories {
  static readonly type = '[Building-State] Get building categories';
  constructor() {}
}

export class ClearBuildingCategories {
  static readonly type = '[Building-State] Clear building categories';
  constructor() {}
}
